import { render, staticRenderFns } from "./MonitorsDashboardSubCategory.vue?vue&type=template&id=7351ad77&"
import script from "./MonitorsDashboardSubCategory.vue?vue&type=script&lang=js&"
export * from "./MonitorsDashboardSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./MonitorsDashboardSubCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports